import {
  afterRenderEffect,
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  DestroyRef,
  ElementRef,
  inject,
  input,
  signal,
  viewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { SvgIconComponent } from 'angular-svg-icon';
import { HeaderFavoriteGame } from '../interfaces/header-games.interface';
import { NgpTooltip, NgpTooltipTrigger } from 'ng-primitives/tooltip';
import NumberFlow from 'number-flow';
import { filter, map } from 'rxjs';

@Component({
  selector: 'app-header-favorite-game',
  imports: [SvgIconComponent, NgpTooltip, NgpTooltipTrigger],
  templateUrl: './header-favorite-game.component.html',
  styleUrl: './header-favorite-game.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeaderFavoriteGameComponent {
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);

  game = input.required<HeaderFavoriteGame>();
  value = input<number | null>(null);

  public readonly isLinkActive = signal(false);

  constructor() {
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        map((e) => e.url.split('/').at(-1)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((route) => {
        this.isLinkActive.set(route === this.game().link);
      });
  }

  valueNumberFlow = viewChild<ElementRef<NumberFlow>>('valueNumberFlow');

  updateValueEffect = afterRenderEffect(async () => {
    const element = this.valueNumberFlow()?.nativeElement;
    const value = this.value();
    if (element && value !== null) {
      element.update(value);
    }
  });

  ngAfterViewInit() {
    const element = this.valueNumberFlow()?.nativeElement;
    const value = this.value();

    if (!element || value === null) return;

    element.locales = 'en-US';
    element.format = {
      minimumIntegerDigits: 1,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };

    element.update(value);
  }

  public handleNavigate() {
    this.router.navigate([this.game().link]);
  }
}
